import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select';
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
export default {
  name: 'InscanNTSShipment',
  components: {
    VueElementLoading,
    BasicSelect,
    Paginate,
    DatePicker
  },
  props: [],
  data() {
    return {
      isLoading: false,
      hubLoading: '',
      EBNDetails: [],
      hub: '',
      hubid: '',
      hubName: '',
      pageNo: 1,
      limit: 10,
      pageCount: 0,
      totalRows: 0,
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      // confirmationmodal: false,
      shippingIDError:'',
      inputString:'',
      timeoutHandler: 0,
      manualInput:false,
      CSMID: ''

    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.hubid = userdetail[0].HubId[0];
    this.createdbyemail = userdetail[0].email;
    this.getLoginHubName(userdetail[0].HubId)
  },
  methods: {
    checkBarcode(e){
      if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString += String.fromCharCode(e.keyCode)
      }
      this.timeoutHandler = setTimeout(() => {
        if (this.inputString.length <= 3) {
          this.manualInput = true
          this.inputString = ''
        }else{
          this.manualInput = false
          this.inputString = ''
        }
      }, 10)
    },
    getLoginHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum)
      this.showOverageDetails()
    },
    // ShowModal(data) {
    //   if (this.ShipmentId == '') {
		// 		this.shippingIDError = "The shipping ID field is required."
		// 	} else {
		// 		this.shippingIDError = ""
    //     this.confirmationmodal = true;
		// 	}
    // },
    fetchEbnDetails() {
      if (this.CSMID == '') {
				this.shippingIDError = "The CSMID field is required."
				return false;
      }else{
        // this.EBNDetails = [{
        //   shippingid: "224874837434",ebn:"839232HJIK8",invoicenumber:"INV8732",invoicedate:new Date()
        // }]

        // console.log(`${apiUrl.api_url_hubops}getebnShipmentDetails?connectionScheduleMasterId=${this.CSMID}`);
        this.input = {}
        axios({
            method: 'GET',
            url: `${apiUrl.api_url_hubops}getebnShipmentDetails?connectionScheduleMasterId=${this.CSMID}`,
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then((response) => {
            if (response.data.ResultCode == 100) {
              this.invalidTokenModal = false
              // this.confirmationmodal = false
              this.EBNDetails = response.data.ResponseData;
              this.$alertify.success(response.data.ReturnMessage)
              this.resetShipment();
              // this.shippingIDError = ''
              // this.showOverageDetails()
            } else if (response.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = response.data.ReturnMessage
              this.$alertify.error(response.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(response.data.ReturnMessage)
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }
    },
    clearError() {
			if (this.CSMID == '') {
				this.shippingIDError = "The CSMID field is required."
			} else {
				this.shippingIDError = ""
			}
		},
    resetForm() {
      this.CSMID = ''
      this.EBNDetails = []
      this.isLoading = false
      this.$validator.reset()
      // this.confirmationmodal = false,
        this.ShippingID = ''
      this.isLoading = false
    },
    resetShipment(){
      this.shippingIDError = '',
      this.manualInput = false
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    // closeModal() {
    //   this.confirmationmodal = false
    //   this.ShippingID = ''
    // },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/EBNShipmentDetails/EbnShipmentDetails.js